import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CircularSpinner = function CircularSpinner(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_jsx("div", {
    className: "webiny-pb-circular-spinner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "webiny-pb-circular-spinner__container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "webiny-pb-circular-spinner__container-loader",
        children: "Loading..."
      }), label && /*#__PURE__*/_jsx("div", {
        className: "webiny-pb-circular-spinner__container-label",
        children: label
      })]
    })
  });
};
export default CircularSpinner;
//# sourceMappingURL=CircularSpinner.js.map